import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { authConstants } from '../../auth.constants';
import { environment } from '../../../../../environments/environment';
import { MuToastService } from 'src/app/components/shared/sharedServices/mu-toast.service';
import { LayoutAuthService } from 'src/app/components/layout/pages/layout-auth/layout-auth.service';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { AuthVerifyCodeActions } from './auth-verify-code.actions.enum';
import { MuException } from 'src/app/components/shared/types/exception.type';
import { MuValidationsSmsService } from 'src/app/components/shared/sharedServices/mu-validations-sms.service';
import { UtilsService } from 'src/app/components/shared/sharedServices/utils.service';

@Component({
  selector: 'app-auth-verify-code',
  templateUrl: './auth-verify-code.component.html',
  styleUrls: ['./auth-verify-code.component.sass'],
})
export class AuthVerifyCodeComponent implements OnInit {
  indicative: string;
  numberPhone: number;
  numberPhoneFormat: string;
  countryid: number;
  verifyCodeform: UntypedFormGroup;
  formInput = ['input1', 'input2', 'input3', 'input4'];
  seconds: number;
  toastLife: number;
  enabledButtonResend: boolean;
  showLoginLoading: boolean;
  showLoginLoadingSms: boolean;
  showErrorCode: boolean;
  actionList: Actions<AuthVerifyCodeActions, any> = new Actions<AuthVerifyCodeActions, any>();
  actionListEnum = AuthVerifyCodeActions;

  constructor(
    private router: Router,
    private muToastService: MuToastService,
    private layoutAuthService: LayoutAuthService<any>,
    private muValidationsSmsService: MuValidationsSmsService,
    private utilsService: UtilsService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initData();
  }

  /**
   * init data
   */
  private async initData(): Promise<void> {
    this.verifyCodeform = this.toFormGroup(this.formInput);
    this.countdown();
    this.toastLife = environment.toastData.life;
    this.getphoneClient();
    this.layoutAuthService.updateSettings({ tab: 1 });
    this.actionList.on(AuthVerifyCodeActions.VERIFY_CODE, (_, __) => {
      this.verifyCodeSubmit();
    });
    this.actionList.on(AuthVerifyCodeActions.RESEND_VERIFY_CODE, (_, __) => {
      this.sendVerifyCode();
    });
  }

  /**
   * method to countdown
   *
   * @private
   * @memberof AuthVerifyCodeComponent.countdown
   */
  private countdown(): void {
    this.enabledButtonResend = false;
    this.seconds = authConstants.seconds;
    const id = setInterval(() => {
      if (this.seconds !== 0) {
        --this.seconds;
      } else {
        clearInterval(id);
        this.enabledButtonResend = true;
      }
    }, 1000);
  }

  /**
   *  method to create input opt
   *
   * @private
   * @param {string[]} elements
   * @return {*} FormGroup
   * @memberof AuthVerifyCodeComponent.toFormGroup
   */
  private toFormGroup(elements: string[]): UntypedFormGroup {
    const group: { [key: string]: AbstractControl } = {};

    elements.forEach(key => {
      group[key] = new UntypedFormControl('', Validators.required);
    });
    return new UntypedFormGroup(group);
  }

  /**
   * method to verify opt
   *
   * @memberof AuthVerifyCodeComponent.verifyCodeSubmit
   */
  async verifyCodeSubmit(): Promise<void> {
    if (this.verifyCodeform.invalid) {
      return environment.guardClause;
    }
    let code = '';
    for (const key in this.verifyCodeform.value) {
      if (key) {
        code = code.concat(this.verifyCodeform.value[key]);
      }
    }
    this.sendCodeSubmit(code);
  }

  /**
   * send code submit
   * @param {string} code
   */
  async sendCodeSubmit(code: string): Promise<void> {
    try {
      this.showErrorCode = false;
      this.showLoginLoading = true;
      await this.muValidationsSmsService.validateCodeSms(this.countryid, this.numberPhone, code);
      this.muValidationsSmsService.showToastVerificationCode(this.muToastService, true);
      this.router.navigate(['/crear-cuenta/datos']);
    } catch (e: any | MuException) {
      this.showErrorCode = true;
      this.showLoginLoading = false;
      this.verifyCodeform.get('input1').setErrors([{ invalid: true }]);
      this.muValidationsSmsService.showToastVerificationCode(this.muToastService, false, e);
    }
  }

  /**
   * method to change phone number
   *
   * @memberof AuthVerifyCodeComponent.changePhoneNumber
   */
  changePhoneNumber(): void {
    const codePhone = localStorage.getItem(authConstants.codePhone);
    if (codePhone === 'yes') {
      this.router.navigate(['/auto-verificacion/crear-cuenta']);
      return environment.guardClause;
    }
    this.router.navigate(['/crear-cuenta']);
  }

  /**
   * method to get the client phone
   *
   * @private
   * @memberof AuthVerifyCodeComponent.getphoneClient
   */
  private getphoneClient(): void {
    const clientPhone = JSON.parse(localStorage.getItem(authConstants.storagePhone));
    if (clientPhone?.country === authConstants.dropdownCountries.co.id) {
      this.indicative = authConstants.dropdownCountries.co.indivative;
    } else if (clientPhone?.country === authConstants.dropdownCountries.mx.id) {
      this.indicative = authConstants.dropdownCountries.mx.indivative;
    }
    this.countryid = clientPhone?.country;
    this.numberPhone = clientPhone?.clientPhone;
    this.numberPhoneFormat = this.utilsService.formatPhoneNumber(clientPhone?.clientPhone)?.replace(/(\d{3}) /g, '*** ');
  }

  /**
   * method to send verify code sms
   *
   * @memberof AuthVerifyCodeComponent.sendVerifyCode
   */
  async sendVerifyCode(): Promise<void> {
    try {
      this.showLoginLoadingSms = true;
      await this.muValidationsSmsService.resendVerifyCode(this.countryid, this.numberPhone);
      this.showLoginLoadingSms = false;
      this.countdown();
    } catch (e: any | MuException) {
      this.showLoginLoadingSms = false;
      this.muValidationsSmsService.showToastErrorValidatePhone(this.muToastService, 'error', e);
    }
  }
}
